import { RouteComponentProps } from 'react-router-dom';
import { InverseDropdown } from './styles'
import { IGroup, IRole } from '@nkr/models/index';
import { AuthRole } from '@nkr/enums/index';
import { NavItem } from 'react-bootstrap';

interface IProps extends RouteComponentProps<{}> {
    firstName: string,
    lastName: string,
    username: string,
    currentUrl: string,
    group: IGroup,
    roles: IRole[]
}

const IldaMenus = (props: IProps) => {
    const isIlda = props.location.pathname.includes('/ilda');
    const canAccessDonorConnect = props.roles.filter(x => x.id >= AuthRole.DonorConnectAccessAll && x.id <= AuthRole.DonorConnectAccessReports).length > 0;

    return (
        <>
            <div className='nkr-menu'>
                <div className='navbar navbar-inverse' style={{ borderRadius: 0, marginBottom: 10 }}>
                    <div className='navbar-header'>
                        <button type='button' className='navbar-toggle' data-toggle='collapse' data-target='.navbar-collapse' style={{ marginTop: 1, height: 18, padding: '5px 18px' }}>
                            <span className='sr-only'>Toggle navigation</span>
                            <span className='icon-bar'></span>
                            <span className='icon-bar'></span>
                            <span className='icon-bar'></span>
                        </button>
                    </div>
                    <div className='navbar-collapse collapse'>
                        <ul className='nav navbar-nav'>
                            <li className={isIlda ? 'dropdown active' : 'dropdown'}>
                                <a href='#' className='dropdown-toggle' data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>ILDA <span className='caret'></span></a>
                                <InverseDropdown className='dropdown-menu'>
                                    <li>
                                        <a href={`/ilda/to-do`}>DASH Registrations</a>
                                        <a href={`/ilda/user-case-load-limits`}>User Case Load Limits</a>
                                    </li>
                                </InverseDropdown>
                            </li>

                            {canAccessDonorConnect && (
                                <NavItem active={props.location.pathname == '/donor-connect/to-do'} href={'/donor-connect/to-do'}>Donor Mentor</NavItem>
                            )}

                            <li className='dropdown'>
                                <a href='#' className='dropdown-toggle' data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Welcome, {props.firstName} {props.lastName} <span className='caret'></span></a>
                                <InverseDropdown className='dropdown-menu'>
                                    <li>
                                        <a href={'/manage-account'}>Manage Account</a>
                                        <a href={'/logout?next=' + props.currentUrl}>Logout</a>
                                    </li>
                                </InverseDropdown>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
}

export default IldaMenus;